"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResizedImageSrcSet = exports.getResizedImageUrl = exports.getResizedImageProps = exports.pow2ceil = void 0;
const config_1 = __importDefault(require("@mapmaker/config"));
const isomorphic_base64_1 = require("isomorphic-base64");
function pow2ceil(v) {
    if (v <= 0) {
        return 0;
    }
    else if (v <= 1) {
        return 1;
    }
    else if (v <= 2) {
        return 2;
    }
    var p = 2;
    while ((v >>= 1)) {
        p <<= 1;
        if (v === 2) {
            break;
        }
    }
    return p * 2;
}
exports.pow2ceil = pow2ceil;
function clamp(value, min, max) {
    if (value < min)
        return min;
    if (value > max)
        return max;
    return value;
}
const GetResizedImageUrlOptionDefaults = {
    minEdgeSize: 64,
    maxEdgeSize: 4096,
};
// Edits info: https://sharp.pixelplumbing.com/api-resize
// Filter info: https://docs.aws.amazon.com/solutions/latest/serverless-image-handler/appendix-d.html
function getResizedImageProps(key, desiredWidth, desiredHeight, options = {}) {
    return {
        src: getResizedImageUrl(key, desiredWidth, desiredHeight, options),
        srcSet: getResizedImageSrcSet(key, desiredWidth, desiredHeight, options),
    };
}
exports.getResizedImageProps = getResizedImageProps;
// Edits info: https://sharp.pixelplumbing.com/api-resize
// Filter info: https://docs.aws.amazon.com/solutions/latest/serverless-image-handler/appendix-d.html
function getResizedImageUrl(key, desiredWidth, desiredHeight, options = {}) {
    const { minEdgeSize, maxEdgeSize } = Object.assign(Object.assign({}, GetResizedImageUrlOptionDefaults), options);
    const edgeSize = clamp(pow2ceil(Math.max(desiredWidth, desiredHeight)), minEdgeSize, // Min edge size
    maxEdgeSize // Max edge size
    );
    // Images at 4096 x 4096 sometimes exceed the 6mb APIGateway limit, which causes them to fail.
    // Bumping the quality down seems to fix the issue.
    const quality = edgeSize > 3000 ? 75 : 100;
    const imageRequest = JSON.stringify({
        bucket: config_1.default.imageServerBucket,
        key,
        edits: Object.assign({ resize: {
                width: edgeSize,
                height: edgeSize,
                fit: "inside",
            } }, (quality === 100
            ? {}
            : {
                jpeg: {
                    quality,
                },
            })),
    });
    return `${config_1.default.userContentImageServerUrl}/${(0, isomorphic_base64_1.btoa)(imageRequest)}`;
}
exports.getResizedImageUrl = getResizedImageUrl;
/**
 * Returns a srcset string at 1x and 2x the size. Specify the desired size at 1x.
 */
function getResizedImageSrcSet(key, desiredWidth, desiredHeight, options = {}) {
    const at1x = getResizedImageUrl(key, desiredWidth, desiredHeight, options);
    const at2x = getResizedImageUrl(key, desiredWidth * 2, desiredHeight * 2, options);
    return [`${at1x} 1x`, `${at2x} 2x`].join(",");
}
exports.getResizedImageSrcSet = getResizedImageSrcSet;
//# sourceMappingURL=data:application/json;base64,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